import { bootstrapApplication } from '@angular/platform-browser';
import { MdsConfig } from '@maersk-global/mds-config';
import { appConfig } from './app/app.config';
import { App } from './app/app';

MdsConfig.iconsDynamicImportPath = '/';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
